import './Marketing.css';

const MarketingSection = ({ currentTenant, config, showToast }) => {
    return (
        <div className="section-marketing fade-in">
            <h2 className="section-main-title">Compartilhar Link</h2>
            <div className="admin-grid-layout">
                <div className="admin-card share-main-card">
                    <div className="share-icon-large">📢</div>
                    <h3 className="card-title">Promova sua Barbearia</h3>
                    <p className="card-description">Use este link para receber agendamentos diretamente dos seus clientes via WhatsApp, Instagram ou Facebook.</p>

                    <div className="share-url-box">
                        <code className="share-url">
                            {window.location.origin + window.location.pathname}?shop={currentTenant}
                        </code>
                        <button
                            className="copy-btn-premium"
                            onClick={() => {
                                const url = `${window.location.origin}${window.location.pathname}?shop=${currentTenant}`;
                                navigator.clipboard.writeText(url);
                                showToast('Link copiado para a área de transferência!');
                            }}
                        >
                            Copiar Link
                        </button>
                    </div>
                </div>

                <div className="admin-card share-tips-card">
                    <h3 className="card-title">Dicas de Marketing</h3>
                    <ul className="marketing-tips-list">
                        <li><strong>Bio do Instagram</strong>: Cole o link na sua biografia para que os clientes agendem sem sair do app.</li>
                        <li><strong>Status do WhatsApp</strong>: Poste o link periodicamente para lembrar seus clientes de agendar.</li>
                        <li><strong>Google Meu Negócio</strong>: Adicione este link como o site oficial de agendamentos no seu perfil do Google.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default MarketingSection;
